module.exports = __webpack_public_path__ + "img/image_001.cde3c1d0.jpg";